import { useState } from "react";
import { Box, Collapse, Grid, IconButton, Paper } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CustomText from "../components/CustomText";

const FrequentlyQuestions = () => {
  const [expanded, setExpanded] = useState(0);

  return (
    <Grid container sx={design.Container}>
      <Grid item size={design.grid1} />
      <Grid item size={design.grid10}>
        <Box textAlign="center" mb={5}>
          <CustomText
            color="#7A2FA4"
            fontWeight={700}
            letterSpacing="2px"
            textTransform="uppercase"
            mb={2}
            fontFamily="Nunito"
            fontSize={design.fontSize12}
            textAlign="center"
            width="100%"
          >
            Resolvemos tus dudas
          </CustomText>
          <CustomText
            color="#213A8F"
            fontWeight={700}
            mb={2}
            fontFamily="Nunito"
            fontSize={design.fontSize34}
            textAlign="center"
            width="100%"
          >
            Preguntas frecuentes
          </CustomText>
        </Box>
        {questions.map((item, index) => {
          const open = expanded === index;
          const handleToggle = () => setExpanded(open ? null : index);
          return (
            <Paper key={index} elevation={0} sx={design.PaperCard(open)}>
              <Box onClick={handleToggle} sx={design.BoxAlig}>
                <CustomText
                  color={open ? "#8E4AC3" : "#333333"}
                  fontWeight={700}
                  mb={2}
                  fontFamily="Nunito"
                  fontSize={17}
                  textAlign="left"
                  width="100%"
                >
                  {item.title}
                </CustomText>

                <IconButton sx={design.IconPlus(open)}>
                  {open ? <RemoveIcon /> : <AddIcon />}
                </IconButton>
              </Box>

              <Collapse in={open}>
                <Box px={3} pb={3}>
                  <CustomText
                    color={"#777777"}
                    fontWeight={700}
                    fontFamily="Plus Jakarta Sans "
                    fontSize={14}
                    textAlign="justify"
                    width="100%"
                  >
                    {item.detail}
                  </CustomText>
                </Box>
              </Collapse>
            </Paper>
          );
        })}
      </Grid>
      <Grid item size={design.grid1} />
    </Grid>
  );
};

export default FrequentlyQuestions;
const design = {
  Container: {
    padding: {
      xs: "35px 0px",
      md: "30px 0px",
    },
  },
  PaperCard: (open) => ({
    mb: 2,
    borderRadius: "18px",
    overflow: "hidden",
    border: open ? "1px solid #C89CF3" : "1px solid #ECE7F3",
    boxShadow: open ? "0px 8px 24px rgba(142, 74, 195,0.12)" : "none",
    transition: ".25s",
  }),
  BoxAlig: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    px: 3,
    py: 2.5,
  },
  IconPlus: (open) => ({
    width: 32,
    height: 32,
    bgcolor: open ? "#8E4AC3" : "#F4ECFB",
    color: open ? "#FFF" : "#8E4AC3",
    "&:hover": {
      bgcolor: open ? "#7B3CB2" : "#ECDDFA",
    },
  }),
  fontSize12: { xs: 12, sm: 12, md: 12, lg: 12 },
  fontSize34: {
    xs: 34,
    md: 40,
  },
  grid1: { xs: 0.5, md: 2 },
  grid10: { xs: 11, md: 8, xl: 8, lg: 8 },
};

const questions = [
  {
    title: "¿Cómo funciona el pre ingreso?",
    detail: "El pre ingreso permite agilizar el proceso antes de tu llegada.",
  },
  {
    title: "¿Mi aseguradora tiene convenio?",
    detail:
      "Trabajamos con múltiples aseguradoras reconocidas a nivel nacional.",
  },
  {
    title: "¿Puedo agendar una cita con un doctor en específico?",
    detail: "Sí, puedes seleccionar el médico que prefieras desde nuestra web.",
  },
  {
    title: "¿Cómo funcionan los servicios a domicilio?",
    detail: "Nuestros profesionales acuden a tu domicilio previa programación.",
  },
];
